/**
 * Utility helper functions
 */

/**
 * Converts a check_id string to Title Case format
 * @param checkId - The check_id string with underscores (e.g., "banner_size_check")
 * @returns Formatted string in Title Case (e.g., "Banner Size Check")
 *
 * @example
 * formatCheckId("grammar_spelling_check") // Returns "Grammar Spelling Check"
 * formatCheckId("banner_size_check") // Returns "Banner Size Check"
 */
export const formatCheckId = (checkId: string): string => {
  // Special case for blur_pixelation_check
  if (checkId.toLowerCase() === "blur_pixelation_check") {
    return "Blur/Pixelation Check";
  }

  return checkId
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => {
      if (word.toLowerCase() === "url") {
        return "URL";
      } else if (word.toLowerCase() === "isi") {
        return "ISI";
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

export const formatChannelValue = (channelLabel: string): string => {
  if (channelLabel === "Email HOE") {
    return "hoe";
  } else if (channelLabel === "Email FTE") {
    return "fte";
  } else if (channelLabel === "Email RTE") {
    return "rte";
  } else if (channelLabel === "Static Banner") {
    return "banner";
  } else if (channelLabel === "Animated Banner") {
    return "animated_banner";
  } else {
    return channelLabel.toLowerCase();
  }
};

export const formatChannelName = (channel: string): string => {
  const channelMap: { [key: string]: string } = {
    banner: "Static Banner",
    fte: "Email FTE",
    hoe: "Email HOE",
    animated_banner: "Animated Banner",
    rte: "Email RTE",
  };
  return channelMap[channel?.toLowerCase()] || channel;
};
